import React, { useContext } from 'react';
import { Button } from 'baseui/button';
import { ModalContext } from 'commons-ui';
import { isEmpty } from 'lodash';

export const ShowReferralDetails: React.FC<{ params: any }> = (params: any) => {
	const { value, header, content } = params;
	const { setModalConfig } = useContext(ModalContext);
	return (
		<>
			{!isEmpty(value) && (
				<Button
					onClick={() =>
						setModalConfig({
							isOpen: true,
							header,
							content
						})
					}
					overrides={{ BaseButton: { style: { width: '100%' } } }}>
					Show Details
				</Button>
			)}
		</>
	);
};

export const getReferralPolicyDetailsModal = (data: any) => {
	return (
		<div style={{ height: '25vw', width: '50vw', overflow: 'auto' }}>
			<pre id='json'>{JSON.stringify(data, null, 2)}</pre>
		</div>
	);
};
